
































































































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import { AuditActingUser, AuditRequest } from '../../../../models/audit/request'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import CHybridTelephone from '~/components/shared/configurable/telephone/CHybridTelephone.vue'
import CDirectionsButton from '~/components/shared/configurable/map/CDirectionsButton.vue'
import { handleError } from '~/utils/http'
import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { useLogger } from '~/compositions/logger'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import AuditProviderShopSelect from '~/components/shared/audits/shop/AuditProviderShopSelect.vue'
import { AuditProviderShop } from '~/models/audit/shop'
import { useDep } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { ciRotate } from '~/icons/source/regular/rotate'

export default defineComponent({
  components: {
    AuditProviderShopSelect,
    CConfirmationModal,
    CDirectionsButton,
    CHybridTelephone,
    CPrice,
    CAvatar
  },
  props: {
    request: {
      type: Object as PropType<AuditRequest>,
      required: true
    }
  },
  setup(props) {
    const { request } = toRefs(props)
    const userIsSeller = computed<boolean>(() => {
      return request.value.currentUserRole === AuditActingUser.SELLER
    })

    const snackbar = useSnackbar()
    const { t } = useI18n()
    const logger = useLogger()
    const showChangeWorkshopModal = ref(false)
    const loading = ref(false)
    const auditRequestService = useDep(AuditRequestService)

    const selectedShop = ref<AuditProviderShop['id'] | null>(null)

    const userIsAuditProvider = computed<boolean>(() => {
      return request.value.currentUserRole === AuditActingUser.AUDIT_PROVIDER
    })
    const directionsLink = computed(() => {
      if (request.value.auditShop.geolocation) {
        return `https://www.google.com/maps/dir/?api=1&destination=${request.value.auditShop.geolocation.lat},${request.value.auditShop.geolocation.lon}`
      }
      return ''
    })

    async function handleShopChange() {
      if (!selectedShop.value) {
        return
      }
      try {
        loading.value = true
        await auditRequestService.changeShop(
          request.value.id,
          selectedShop.value
        )
        snackbar.success(t('audit shop changed successfully') as string)
        window.location.reload()
      } catch (err) {
        handleError(err, snackbar, logger, t)
      } finally {
        loading.value = false
      }
    }

    return {
      userIsSeller,
      directionsLink,
      userIsAuditProvider,
      ciRotate,
      showChangeWorkshopModal,
      loading,
      handleShopChange,
      selectedShop
    }
  }
})
